// extracted by mini-css-extract-plugin
export var orderDetails = "_sg-2";
export var orderImage = "_sg-1";
export var orderMeta = "_sg-3";
export var orderSummary = "_sg-0";
export var rightArrow = "_sg-4";